import { CustomTag } from '../../../../CustomIcon';
import Paragraph from '../../../../Typography/Paragraph';
var MultiSelectFullNoResult = function (_a) {
    var title = _a.title, text = _a.text;
    return (<div className="mt-8 flex flex-col items-center gap-4">
      <CustomTag size={70}/>
      <div className="flex flex-col items-center">
        <Paragraph size="xs" bold center>
          {title}
        </Paragraph>
        <Paragraph size="xs" center>
          {text}
        </Paragraph>
      </div>
    </div>);
};
export default MultiSelectFullNoResult;
